import * as tslib_1 from "tslib";
import { TextureBaseGLES } from "./TextureBaseGLES";
var CubeTextureGLES = (function (_super) {
    tslib_1.__extends(CubeTextureGLES, _super);
    function CubeTextureGLES(context, gl, size, id) {
        var _this = _super.call(this, context, gl, id) || this;
        _this._textureSelectorDictionary = new Array(6);
        _this.textureType = "textureCube";
        _this._size = size;
        return _this;
        //todo
        // this._glTexture = this._gl.createTexture();
        //
        // this._textureSelectorDictionary[0] = gl.TEXTURE_CUBE_MAP_POSITIVE_X;
        // this._textureSelectorDictionary[1] = gl.TEXTURE_CUBE_MAP_NEGATIVE_X;
        // this._textureSelectorDictionary[2] = gl.TEXTURE_CUBE_MAP_POSITIVE_Y;
        // this._textureSelectorDictionary[3] = gl.TEXTURE_CUBE_MAP_NEGATIVE_Y;
        // this._textureSelectorDictionary[4] = gl.TEXTURE_CUBE_MAP_POSITIVE_Z;
        // this._textureSelectorDictionary[5] = gl.TEXTURE_CUBE_MAP_NEGATIVE_Z;
    }
    CubeTextureGLES.prototype.uploadFromImage = function (imageCube, side, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        //todo
        // this._gl.bindTexture(this._gl.TEXTURE_CUBE_MAP, this._glTexture);
        // this._gl.texImage2D(this._textureSelectorDictionary[side], miplevel, this._gl.RGBA, this._gl.RGBA, this._gl.UNSIGNED_BYTE, data);
        // this._gl.bindTexture(this._gl.TEXTURE_CUBE_MAP, null);
    };
    CubeTextureGLES.prototype.uploadCompressedTextureFromByteArray = function (data, byteArrayOffset /*uint*/, async) {
        //todo
        if (async === void 0) { async = false; }
    };
    Object.defineProperty(CubeTextureGLES.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    return CubeTextureGLES;
}(TextureBaseGLES));
export { CubeTextureGLES };



// WEBPACK FOOTER //
// ../dist/lib/gles/CubeTextureGLES.js